module.exports = __webpack_public_path__ + "img/joint.08aaf43.jpg";